declare global {
  interface Window {
    webkitAudioContext?: typeof AudioContext;
  }
}

export const formatDurationLabel = (totalSeconds: number): string => {
  const safeSeconds = Number.isFinite(totalSeconds) ? Math.max(0, Math.round(totalSeconds)) : 0;
  const minutes = Math.floor(safeSeconds / 60);
  const seconds = safeSeconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const getAudioDurationSeconds = async (
  arrayBuffer: ArrayBuffer,
): Promise<number> => {
  if (typeof window === 'undefined') {
    return 0;
  }

  const AudioContextConstructor =
    window.AudioContext || window.webkitAudioContext;

  if (!AudioContextConstructor) {
    return 0;
  }

  const audioContext = new AudioContextConstructor();

  try {
    const audioBuffer = await audioContext.decodeAudioData(
      arrayBuffer.slice(0),
    );
    return audioBuffer.duration;
  } catch (error) {
    console.error('Failed to decode audio data', error);
    return 0;
  } finally {
    try {
      if (typeof audioContext.close === 'function') {
        await audioContext.close();
      }
    } catch (closeError) {
      console.warn('Failed to close audio context', closeError);
    }
  }
};

export const determineAudioExtension = (mimeType: string | undefined): string => {
  if (!mimeType) {
    return 'm4a';
  }

  if (mimeType.includes('mp4') || mimeType.includes('aac')) {
    return 'm4a';
  }

  if (mimeType.includes('mpeg')) {
    return 'mp3';
  }

  if (mimeType.includes('wav')) {
    return 'wav';
  }

  if (mimeType.includes('ogg')) {
    return 'ogg';
  }

  return 'm4a';
};


